import { useProfile } from "@brg/auth"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import {
    clearUserCurrenciesRequest,
    getUserAccounts,
    selectorUserCurrencies
} from "../slices/userCurrenciesSlice";


export const useUserBalance = () => {
    const profile = useProfile()
    const userBalance = useSelector(selectorUserCurrencies)
    const dispatch = useDispatch()
    const { i18n } = useTranslation()

    useEffect(() => () => {
        dispatch(clearUserCurrenciesRequest())
    }, [])

    useEffect(() => {
        if (!profile || userBalance?.currencies?.length || userBalance?.loading) {
            return
        }
        dispatch(getUserAccounts({
            lang: i18n.language
        }))
    }, [profile?.accountId, i18n.language, userBalance])
    
    return { userBalance }
}import { useProfile } from "@brg/auth"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import {
    clearUserCurrenciesRequest,
    getUserAccounts,
    selectorUserCurrencies
} from "../slices/userCurrenciesSlice";


export const useUserBalance = () => {
    const profile = useProfile()
    const userBalance = useSelector(selectorUserCurrencies)
    const dispatch = useDispatch()
    const { i18n } = useTranslation()

    useEffect(() => () => {
        dispatch(clearUserCurrenciesRequest())
    }, [])

    useEffect(() => {
        if (!profile || userBalance?.currencies?.length || userBalance?.loading) {
            return
        }
        dispatch(getUserAccounts({
            lang: i18n.language
        }))
    }, [profile?.accountId, i18n.language, userBalance])
    
    return { userBalance }
}